import { writable } from "svelte/store";
export type ReferralCodeStore = {
  code: string;
};
const initialReferralCodeStore: ReferralCodeStore = {
  code: null,
};
export const referralCodeStore = writable<ReferralCodeStore>(initialReferralCodeStore);
